import React from "react"
import {Separator} from "~/common/components/atoms/separator"
import {Container} from "~/common/components/templates/container"
import IconFacebook from "./assets/facebook.inline.svg"
import IconLinkedIn from "./assets/linkedin.inline.svg"
import IconTwitter from "./assets/twitter.inline.svg"
import "./footer.scss"

type Props = {
  useSeparator?: boolean
}

export function Footer({useSeparator}: Props) {
  return (
    <footer className="footer">
      <Container>
        {useSeparator && <Separator />}
        <ul className="footer-menu">
          {/* <li className="footer-menu__link w-200 inline-block">Privacy notice</li> */}
          <li className="footer-menu__link">
            <ul className="footer-menu footer-menu_social">
              <li>
                {/* <a href="https://twitter.com/doxproapp"> */}
                <a>
                  <IconTwitter />
                </a>
              </li>
              <li>
                {/* <a href="https://www.facebook.com/doxprokit"> */}
                <a>
                  <IconFacebook />
                </a>
              </li>
              <li>
                {/* <a href="https://www.linkedin.com/company/doxpro-office-kit"> */}
                <a>
                  <IconLinkedIn />
                </a>
              </li>
              {/* <li>
								<a href="https://t.me/doxpro">Telegram</a>
							</li> */}
            </ul>
          </li>
          <li className="footer-menu__link copyright">
            <span className="text-no-wrap">© 2021. Doxpro. All rights reserved.</span>
          </li>
        </ul>
      </Container>
    </footer>
  )
}
